import styled, { css } from 'styled-components';

// T-L09 (owner rule L14): the To cell of the transfers list. A Storage ->
// Storage transfer split over events shows them with the storage, muted and
// cut to fit (the full list in the tooltip): under it in the desktop table
// (the row keeps its height), on the same line in the tablet / phone cards
// (so the card's two columns stay level).
const Wrap = styled.span`
  display: flex;
  min-width: 0;
  ${({ theme }) =>
    theme.responsive?.isDesktop
      ? css`
          flex-direction: column;
        `
      : css`
          gap: 4px;
          align-items: baseline;
        `}
`;

const Line = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

// the storage name never gives way to the events
const Name = styled(Line)`
  flex-shrink: 0;
  max-width: 100%;
`;

const Events = styled(Line)`
  min-width: 0;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

export const TransferDestination = ({
  name,
  events,
}: {
  name?: string;
  events: string;
}) => (
  <Wrap>
    <Name title={name}>{name}</Name>
    <Events title={`For ${events}`}>For {events}</Events>
  </Wrap>
);

// The list cell value. Without events it stays the plain name (or undefined),
// exactly as before T-L09: ListCard gives a string/undefined its own cell
// (with the "-" placeholder), but renders an element in a bare Fragment, so
// an empty Fragment (a deleted destination storage has no name) took no grid
// cell and shifted the rest of the row one column left.
export const transferDestinationValue = ({
  name,
  events,
}: {
  name?: string;
  events: string;
}) => (events ? <TransferDestination name={name} events={events} /> : name);
